import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../../helpers/custom-prop-types';
import SplitText from '../../../Ui/Common/SplitText';
const Caution = ({ text }) => {
    if (!text) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'l-container-12 s-contents' }, { children: [_jsx("h2", { children: "\u6CE8\u610F\u4E8B\u9805" }), _jsx("div", Object.assign({ className: 's-contents-inner' }, { children: _jsx(SplitText, { text: text }) }))] })));
};
Caution.propTypes = {
    text: propStr(),
};
Caution.defaultProps = {
    text: '',
};
export default Caution;
